import { render, staticRenderFns } from "./RiskDiagnosisFilters.vue?vue&type=template&id=f9fc0bba"
import script from "./RiskDiagnosisFilters.vue?vue&type=script&lang=js"
export * from "./RiskDiagnosisFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports